import { ITypedReduxAction } from '../../types/redux/actionType';
import { ITag } from '../../types/tags';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ETagsActionTypes {
  AddTag = 'TAGS/ADD_TAG',
  SetTags = 'TAGS/SET_TAGS',
}

export type TSetTags = ITypedReduxAction<ETagsActionTypes.SetTags, ITag[]>;
export type TAddTag = ITypedReduxAction<ETagsActionTypes.AddTag, ITag>;

/**
 * Redux action, который записывает в store список тегов
 * @param promos ISearchPromosResponse
 */
export const setTags: (tags: ITag[]) => TSetTags = actionGenerator<ETagsActionTypes.SetTags, ITag[]>(
  ETagsActionTypes.SetTags,
);

/**
 * Redux action, который добавляет в store новый тег
 * @param promos ISearchPromosResponse
 */
export const addTag: (tag: ITag) => TAddTag = actionGenerator<ETagsActionTypes.AddTag, ITag>(ETagsActionTypes.AddTag);

export type TTagsActionTypes = TSetTags | TAddTag;
